
import React from 'react' 
import AccountCard from '../../components/AccountCard/AccountCard' 
import Button from '../../components/Button/Button'
import { Colors } from '../../design/Colors';
import { Fonts } from '../../design/Font';
 
import Textbox from '../../components/Textbox/Textbox';


export default class FindAccount extends React.Component{

    constructor(props){
        super(props);
        this.parentRef = React.createRef();
        this.state={
           
        }
    }
    
    componentDidMount=()=>{
    }

    render(){
        return (
        <div style={{ display:'flex',flexDirection:'column',flex:3, paddingTop:'2.4vh', paddingLeft:"1vw",paddingRight:'20vw'}}>
            <div>{/**Title*/}
                <span style={{...Fonts.supertitle,color:'#000'}}>Manage Accounts / <span style={{color:"#003F97"}}>Find Account</span></span>
            </div>
            <div style={{background:"#FFF",width:"46.3vw", border:'1px solid rgba(215,215,215,1)',borderRadius:5, marginTop:"2.4vh", paddingLeft:'2.8vh',paddingRight:'2.4vh',paddingTop:'2.4vh'}}>{/**My Active Cards Container*/}
                <div style={{display:'flex', justifyContent:'space-between',marginBottom:'2.5vh'}} ><span style={{...Fonts.supertitle, color:'#000'}}>Search Account</span></div>
               <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between'}}>
                   <Textbox title="First name"  onChange={(value)=>{this.setState({firstname:value.target.value})} } errorMessage={this.state.firstname_error}></Textbox>
                   <Textbox title="Last Name"  onChange={(value)=>{this.setState({lastname:value.target.value})} } errorMessage={this.state.lastname_error}></Textbox>
                   <Textbox title="Date of Birth"  onChange={(value)=>{this.setState({dob:value.target.value})} } errorMessage={this.state.dob_error}></Textbox>
               </div>
               <div style={{display:'flex',flexDirection:'row',justifyContent:'space-between',alignItems:'center', width:'100%',marginTop:'2.5vh', paddingBottom:'2.5vh'}}>
                   <Textbox title="Social Security (last 4 digits)"  onChange={(value)=>{this.setState({firstname:value.target.value})} } errorMessage={this.state.firstname_error}></Textbox>
                   <Button title='Search' width='6vw' height='4vh'/>
                   <Button title='Reset'  width='6vw' height='4vh' color={Colors.dark_grey}/>
                </div>
            </div>
            <div style={{background:"#FFF",width:"46.3vw", border:'1px solid rgba(215,215,215,1)',borderRadius:5, marginTop:"2.4vh", paddingLeft:'2.8vh',paddingRight:'2.4vh',paddingTop:'2.4vh'}}>{/**My Active Cards Container*/}
                <div style={{display:'flex', justifyContent:'space-between',marginBottom:'2.5vh'}} ><span style={{...Fonts.supertitle, color:'#000'}}>Search Results</span></div>
                <div style={{display:'flex', flexDirection:'row',marginTop:'2.6vh'}}>
                    <div style={{width:'6vw', marginLeft:'1.4vw'}}><span style={{...Fonts.subtext, color:Colors.dark_grey}}>Account ID</span></div>
                    <div style={{width:'7.8vw'}}><span style={{...Fonts.subtext, color:Colors.dark_grey}}>Account Name</span></div>
                    <div style={{width:'7vw'}}><span style={{...Fonts.subtext, color:Colors.dark_grey}}>Date Created</span></div>
                    <div style={{width:'6vw'}}><span style={{...Fonts.subtext, color:Colors.dark_grey}}>Date Closed</span></div>
                    <div style={{width:'6vw'}}><span style={{...Fonts.subtext, color:Colors.dark_grey}}>Status</span></div>
                    <div style={{width:'7vw'}}><span style={{...Fonts.subtext, color:Colors.dark_grey}}>Select Action</span></div>
                </div>
                <div style={{marginBottom:'10vh'}}>
                    <div style={{cursor:'pointer'}} onClick={()=>this.props.detailAccount('AC123456')}>
                        <AccountCard account_id='AC123456' account_name="John Doe" account_created="June 13, 2023" account_closed="NA" status={true} />
                    </div>
                </div>
            </div>
        </div>
    )}
}


